<template>
  <div class="container">
    <dl class="credits__total">
      <dt class="credits__total-label">Your Credits</dt>
      <dt class="credits__total-value">-{{ formatMoney(totalCredits) }}</dt>
    </dl>
    <dl v-if="showLineItems" class="credits__line-items">
      <dt v-for="product in products" :key="product.autoBillId">
        <dl class="credits__product">
          <dt>
            <div class="credits__product-name">{{ product.name }}</div>
            <div class="credits__product-expiration">{{ formatDate(product.endDate)}}</div>
          </dt>
          <dt v-if="loading" class="credits__total-value"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></dt>
          <dt v-else class="credits__product-credits">-{{ formatMoney(product.discount.amount) }}</dt>
        </dl>
      </dt>
    </dl>
    <div class="credits__display-line-items">
      <button class="credits__action" @click="showLineItems = !showLineItems">View applied credits
        <!--This syntax correct?-->
        <i v-if="showLineItems">
          <i class="fa-solid fa-chevron-up"></i>
        </i>
        <i v-else>
          <i class="fa-solid fa-chevron-down"></i>
        </i>
      </button>
    </div>
  </div>
</template>

<script>
import formatDateMixin from "@/mixins/formatDateMixin";
import formatMoneyMixin from "@/mixins/formatMoneyMixin";

export default {
  name: "SubscriptionCredits",
  props: {
    products: {
      type: Array,
      required: true
    },
    totalCredits: {
      type: Number,
      required: true
    }
  },
  mixins: [formatDateMixin, formatMoneyMixin],
  data() {
    return {
      showLineItems: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/mixins.scss';

.container{
  color: #FFF;
}

.credits__line-items {
  padding-left: 15px;
}
.credits__product {
  @include line-item-style(inherit);
}
.credits__product-expiration {
  @include note-text;
  text-align: left !important;
}
dl.credits__total {
  @include line-item-style;
}
.credits__total-label {
  font-size: 1em;
  align-self: center;
}
.credits__action {
  display: block;
  margin-left: auto;
  font: bold 0.9em var(--default-font-stack);
  color: var(--tmf-lt-yellow);
  text-decoration: underline;

  i {
    display: inline-block;
  }
}
</style>
